import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    container: {
        marginTop: 40,
        flexDirection: 'row',
        width: 216,
        alignSelf: 'center',
        justifyContent: 'space-between',
    },
    item: {
        alignItems: 'center',
        justifyContent: 'center',
        width: 48,
        height: 88,
    },
    visibleCharacter: {
        fontSize: 48,
        includeFontPadding: false,
        textAlignVertical: 'center',
    },
});

export default styles;
